// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3yHPV","fileBtn":"File_fileBtn__39Tfn","closeBtn":"File_closeBtn__1qeze","fileSelected":"File_fileSelected__1_sug","disabled":"File_disabled__heHFn"};